import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';
import { Bg, StyledContainer } from './styled';

type ContainerProps = {
  bg?: string;
  isLoading?: boolean;
  loadWithoutUnmounting?: boolean;
  variant?: 'dark' | 'light';
  className?: string;
  children?: ReactNode;
};

const Container: FC<ContainerProps> = ({
  bg,
  children,
  variant,
  isLoading,
  loadWithoutUnmounting,
  className,
  ...props
}) => {
  const childrenMounted = loadWithoutUnmounting || !isLoading;

  return (
    <Bg bg={bg} isLoading={isLoading} {...props}>
      {isLoading && <Spinner variant={variant} />}
      {childrenMounted && (
        <StyledContainer
          className={className}
          style={{ display: isLoading ? 'none' : undefined }}
        >
          {children}
        </StyledContainer>
      )}
    </Bg>
  );
};

Container.propTypes = {
  bg: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  loadWithoutUnmounting: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};

Container.defaultProps = {
  bg: '',
  className: '',
  isLoading: false,
  children: null,
  variant: 'light'
};

export default Container;
